import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({ numberInput: { '& .MuiFilledInput-input': { padding: theme.spacing(1.2) } } }));
